import React from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'

import PreviewButton from '../Editor/PreviewButton'
import ShareButton from '../Editor/ShareButton'
import { Spacer } from '../App/Navbar'
import AppSwitcher from './AppSwitcher'
import OrgAppSwitcher from './OrgAppSwitcher'

import './Nav.scss'

const EditorNav = props => {
  const { hasTeamSwitcher } = useFlags()

  return (
    <>
      {hasTeamSwitcher ? <OrgAppSwitcher /> : <AppSwitcher />}
      <Spacer />
      <PreviewButton />
      <ShareButton />
    </>
  )
}

export default EditorNav
